export const ScoreConst = [
    {
   "crop_name": "Fish farm",
   "crop_id": 1,
   "growthParameter":
   {
       "growth_period": [1, 52],
       "growth_period_month": [1,12],
       "scoring_fn": 'average',
       "perf_score": [-2, -1, 0, 0.05, 0.1],
       "risk_score": [0.8, 0.75, 0.65, 0.55, 0.5]
   }
   },
       {
   "crop_name": "sugarcane",
   "crop_id": 2,
   "growthParameter":
   {
       "growth_period_week": [20, 52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score": [0.6, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.5, 0.45, 0.4, 0.35, 0.25]
   }
   },
        
      {
   "crop_name": "Grove",
   "crop_id": 3,
   "growthParameter":
   {
       "growth_period_week": [1, 52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score": [0.6, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.45, 0.35, 0.25, 0.15, 0.1]
   }
   },
      
    {
   "crop_name": "Banana",
   "crop_id": 4,
   "growthParameter":
   {
       "growth_period_week": [13, 52],
       "scoring_fn": 'max',
       "growth_period_month": [1,12],
       "perf_score": [0.6, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.35, 0.3, 0.25, 0.15, 0.05]
   }
   },
    
     {
   "crop_name": "Builtup_barren",
   "crop_id": 5,
   "growthParameter":
   {
       "growth_period_week": [1, 52],
       "growth_period_month": [1,12],
       "scoring_fn": 0,
       "perf_score": [9.0,9.0,9.0,9.0,9.0,9.0],
       "risk_score": [0.5, 0.45, 0.4, 0.35, 0.25]
   }
   },
     
     {
   "crop_name": "Horticulture_plantation",
   "crop_id": 6,
   "growthParameter":
   {
       "growth_period_week": [1, 52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score": [0.6, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },
     
    {
   "crop_name": "GRAM",
   "crop_id": 7,
   "growthParameter":
   {
       "growth_period_week": [1, 10],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score": [0.55, 0.5, 0.45, 0.4, 0.35],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },
    
     {
   "crop_name": "Kharif Groundnut",
   "crop_id": 8,
   "growthParameter":
   {
       "growth_period_week": [22, 52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
       "perf_score": [0.55, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },
     
    {
   "crop_name": "Fallow",
   "crop_id": 9,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score": [9.0,9.0,9.0,9.0,9.0,9.0],
       "risk_score": [0.35, 0.25, 0.15, 0.1, 0.05]
   }
   },
    
     {
   "crop_name": "Waterbody",
   "crop_id": 10,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score":  [-0.1, -0.05, 0, 0.05, 0.1],
       "risk_score": [0.9, 0.85, 0.75, 0.65, 0.6]
   }
   },
     
      {
   "crop_name": "Grape",
   "crop_id": 11,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score":  [0.6, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.5, 0.45, 0.35, 0.25, 0.1]
   }
   },
      
      {
   "crop_name": "Sun flower",
   "crop_id": 12,
   "growthParameter":
   {
       "growth_period_week": [30,52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },
      
    {
   "crop_name": "Coconut",
   "crop_id": 13,
   "growthParameter":
   {
       "growth_period_week": [0,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },
    
    {
   "crop_name": "HorticultureShortCycle",
   "crop_id": 14,
   "growthParameter":
   {
       "growth_period_week": [0,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },
     
    {
   "crop_name": "Horticulture Other",
   "crop_id": 15,
   "growthParameter":
   {
       "growth_period_week": [0,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },

     {
   "crop_name": "kharif_paddy",
   "crop_id": 16,
   "growthParameter":
   {
       "growth_period_week": [30,52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.45, 0.4, 0.35, 0.3, 0.2]
   }
   },
     
     {
   "crop_name": "Pomegranate_orange",
   "crop_id": 17,
   "growthParameter":
   {
       "growth_period_week": [0,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score": [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.15]
   }
   },
     
    {
   "crop_name": "Rabi Tobacco",
   "crop_id": 18,
   "growthParameter":
   {
       "growth_period_week": [42,60],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },
    
   {
   "crop_name": "Cashew",
   "crop_id": 19,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },

   {
   "crop_name": "Rabi cereal",
   "crop_id": 20,
   "growthParameter":
   {
       "growth_period_week": [42,56],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.25],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },

    {
   "crop_name": "Pulses",
   "crop_id": 21,
   "growthParameter":
   {
       "growth_period_week": [42,56],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score":  [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },
    
   {
   "crop": "soyabean",
   "crop_id": 22,
   "growthParameter":
   {
       "growth_period_week": [26, 52],
       "growth_period_month": [6,12],
       "scoring_fn": 'max',
       "perf_score": [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
     
   }
   },
    
       
   {
   "crop_name": "cotton",
   "crop_id": 23,
   "growthParameter":
   {
       "growth_period_week": [26, 52],
       "growth_period_month": [6,12],
       "scoring_fn": 'max',
       "perf_score": [0.45, 0.40, 0.35, 0.25, 0.2],
       "risk_score": [0.4, 0.35, 0.3, 0.25, 0.1]
   }
   },

   {
   "crop_name": "Kharif potato",
   "crop_id": 24,
   "growthParameter":
   {
       "growth_period_week": [26, 52],
       "growth_period_month": [6,12],
       "scoring_fn": 'max',
       "perf_score": [0.45, 0.40, 0.35, 0.25, 0.2],
       "risk_score": [0.45, 0.4, 0.35, 0.25, 0.1]
   }
   },

   {
   "crop_name": "Kharif maize",
   "crop_id": 25,
   "growthParameter":
   {
       "growth_period_week": [26, 52],
       "growth_period_month": [6,12],
       "scoring_fn": 'max',
       "perf_score": [0.5, 0.40, 0.30, 0.25, 0.20],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },


   {
   "crop_name": "Late Kharif onion",
   "crop_id": 26,
   "growthParameter":
   {
       "growth_period_week": [32, 52],
       "growth_period_month": [8,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.4, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },

   {
   "crop_name": "Kharif chilli",
   "crop_id": 27,
   "growthParameter":
   {
       "growth_period_week": [26, 52],
       "growth_period_month": [6,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.40, 0.35, 0.30, 0.25],
       "risk_score": [0.40, 0.30, 0.20, 0.1, 0.05]
   }
   },


    {
   "crop_name": "Guar",
   "crop_id": 28,
   "growthParameter":
   {
       "growth_period_week": [48, 14],
       "growth_period_month": [11,14],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.35, 0.30, 0.25],
       "risk_score": [0.05, 0.1, 0.15, 0.18, 0.20]
   }
   },
    
    
   
    {
   "crop_name": "Other",
   "crop_id": 29,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,52],
       "scoring_fn": 'max',
       "perf_score":  [999,999,999,999,999],
       "risk_score": [0.45, 0.35, 0.25, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Mustered",
   "crop_id": 30,
   "growthParameter":
   {
       "growth_period_week": [40,62],
       "growth_period_month": [11,14],
       "scoring_fn": 'max',
       "perf_score": [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
    
    {
   "crop_name": "Rabi garlic",
   "crop_id": 31,
   "growthParameter":
   {
       "growth_period_week": [48,62],
       "growth_period_month": [11,14],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
    
    {
   "crop_name": "Wheat",
   "crop_id": 32,
   "growthParameter":
   {
       "growth_period_week": [40,62],
       "growth_period_month": [11,14],
       "scoring_fn": 'max',
       "perf_score": [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Millet",
   "crop_id": 33,
   "growthParameter":
   {
       "growth_period_week": [26,52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
       "perf_score": [0.5, 0.4, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
   // {
   // "crop_name": "Millet",
   // "crop_id": 33,
   // "growthParameter":
   // {
   //     "growth_period": [24,40],
   //     "scoring_fn": 'max',
   //     "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
   //     "risk_score": [0.05, 0.1, 0.15, 0.18, 0.20]
   // }
   // },

    {
   "crop_name": "Finger Millet",
   "crop_id": 34,
   "growthParameter":
   {
       "growth_period_week": [26,52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
        "perf_score":  [0.5, 0.4, 0.35, 0.30, 0.2],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
     {
   "crop_name": "Shorghum",
   "crop_id": 35,
   "growthParameter":
   {
       "growth_period_week": [26,52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.4, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
     
     {
   "crop_name": "WasteLand",
   "crop_id": 36,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,52],
       "scoring_fn": 'max',
       "perf_score":   [9.0, 9.0, 9.0, 9.0, 9.0],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
     
    {
   "crop_name": "Rabi coriander",
   "crop_id": 37,
   "growthParameter":
   {
       "growth_period_week": [44,52],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.40, 0.35, 0.30, 0.25],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Forest",
   "crop_id": 38,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.55, 0.45, 0.35, 0.3, 0.25]
   }
   },
    
    {
   "crop_name": "mango Plantation",
   "crop_id": 39,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [7,12],
       "scoring_fn": 'max',
        "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Redgram",
   "crop_id": 40,
   "growthParameter":
   {
       "growth_period_week": [34,52],
       "growth_period_month": [7,11],
       "scoring_fn": 'max',
      "perf_score":  [0.50, 0.40, 0.35, 0.25, 0.2],
       "risk_score": [0.35, 0.25, 0.15, 0.15, 0.1]
   }
   },
    
   {
   "crop_name": "Sugarcane adsali",
   "crop_id": 44,
   "growthParameter":
   {
       "growth_period_week": [22,52],
       "growth_period_month": [4,12],
       "scoring_fn": 'max',
       "perf_score":  [0.55, 0.5, 0.45, 0.4, 0.35],
       "risk_score": [0.45, 0.35, 0.25, 0.2, 0.15]
   }
   },

   {
   "crop_name": "Sugarcane suru",
   "crop_id": 45,
   "growthParameter":
   {
       "growth_period_week": [16,52],
       "growth_period_month": [4,12],
       "scoring_fn": 'max',
       "perf_score":  [0.55, 0.5, 0.45, 0.4, 0.35],
       "risk_score": [0.45, 0.35, 0.25, 0.2, 0.15]
   }
   },

    {
   "crop_name": "Rabi sesame",
   "crop_id": 46,
   "growthParameter":
   {
       "growth_period_week": [48,60],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
     "perf_score":  [0.55, 0.5, 0.45, 0.4, 0.35],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },

    {
   "crop_name": "Rabi Lentil",
   "crop_id": 48,
   "growthParameter":
   {
       "growth_period_week": [48,60],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },
    
    {
       "crop_name": "Castor",
       "crop_id": 49,
       "growthParameter":
   {
       "growth_period_week": [26,44],
       "growth_period_month": [7,10],
       "scoring_fn": 'max',
       "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Masur",
   "crop_id": 50,
   "growthParameter":
   {
       "growth_period_week": [48,60],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
      "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Chick pea",
   "crop_id": 51,
   "growthParameter":
   {
       "growth_period_week": [48,60],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },

    {
   "crop_name": "Lin seed",
   "crop_id": 52,
   "growthParameter":
   {
       "growth_period_week": [48,60],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
      "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
      "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Pea",
   "crop_id": 53,
   "growthParameter":
   {
       "growth_period_week": [48,60],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
       "risk_score": [0.35, 0.25, 0.2, 0.15, 0.1]
   }
   },
    
    {
   "crop_name": "Woodland",
   "crop_id": 54,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,52],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.45, 0.35, 0.25, 0.2, 0.15]
   }
   },
    
     {
   "crop_name": "Rabi Shorghum",
   "crop_id": 55,
   "growthParameter":
   {
       "growth_period_week": [48,62],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
       "risk_score": [0.45, 0.35, 0.25, 0.2, 0.15]
   }
     },
     
     
     {
   "crop_name": "Wetland",
   "crop_id": 56,
   "growthParameter":
   {
       "growth_period_week": [1,52],
       "growth_period_month": [1,52],
       "scoring_fn": 'max',
       "perf_score":  [0.5, 0.45, 0.4, 0.35, 0.3],
       "risk_score": [0.45, 0.35, 0.25, 0.2, 0.15]
   }
   },
     
      {
   "crop_name": "Coerce_Cereal_Rabi",
   "crop_id": 57,
   "growthParameter":
   {
       "growth_period_week": [48,62],
       "growth_period_month": [12,14],
       "scoring_fn": 'max',
       "perf_score":  [0.50, 0.45, 0.35, 0.3, 0.2],
       "risk_score": [0.45, 0.35, 0.25, 0.2, 0.15]
   }
   },
]